import { Route, Routes } from "react-router-dom";
import { RequireAuth } from "../../utils/auth/auth";
import ASICExemption from "../../pages/V3/ASICExemption/ASICExemption";
import AddASICExemption from "../../pages/V3/ASICExemption/AddASICExemption/AddASICExemption";

export default function AsicExemptionRouter() {
  return (
    <Routes>
      <Route
        path=""
        element={
          <RequireAuth>
            <ASICExemption />
          </RequireAuth>
        }
      />
      <Route
        path="add"
        element={
          <RequireAuth>
            <AddASICExemption />
          </RequireAuth>
        }
      />
    </Routes>
  );
}
